import React from "react";
import nl2br from "react-nl2br";
import {SongType} from "../data/songs";


export default function Song({ song, full }: { song: SongType, full: boolean }) {
  return (
      <div>
        {full ? (
          <>
            <h3 style={{marginBottom: 5}}>{song.title}</h3>
            {song.subTitle && (
              <small>
                <i>{song.subTitle}</i>
              </small>
            )}
          </>
        ) : (
          <>
            <a href={"/songs/" + song.slug}>
              <h3 style={{marginBottom: 5}}>{song.title}</h3>
            </a>
            {song.subTitle && (
                <small>
                  <i>{song.subTitle}</i>
                </small>
            )}
          </>
        )}
        <hr className={"separator"} />
        <div className={"dream"}>
          {song.audio && <audio controls src={song.audio} />}
          <p>
            <i>{nl2br(song.lyrics)}</i>
          </p>
        </div>
      </div>
  )
}